import Icon from '@amzn/awsui-components-core/icon';
import React from 'react';
import { StockQuote } from 'src/services/StockQuoteService';
import { STOCK_URL } from '../utils/welcome-banner-utils';

interface StockCardProps {
  stock: StockQuote;
  ariaLabel: string;
}

/**
 * @feature landing-page
 * @description Stock price glanceable card — shows AMZN price, daily change (% with arrow),
 * and "Since Day 1" hire date growth if available.
 */
const StockCard: React.FC<StockCardProps> = ({ stock, ariaLabel }) => {
  const isPositive = stock.change >= 0;
  const strokeColor = isPositive ? '#16a34a' : '#dc2626';

  return (
    <div className="landing-welcome-banner__card" data-testid="stock-card">
      <a className="landing-welcome-banner__card-link" href={STOCK_URL} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
        <Icon name="external" size="small" />
      </a>
      <span className="landing-welcome-banner__card-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke={strokeColor}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {isPositive ? (
            <>
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
              <polyline points="16 7 22 7 22 13" />
            </>
          ) : (
            <>
              <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
              <polyline points="16 17 22 17 22 11" />
            </>
          )}
        </svg>
      </span>
      <div className="landing-welcome-banner__card-content">
        <span className="landing-welcome-banner__card-label">{stock.symbol}</span>
        <span className="landing-welcome-banner__card-value">
          ${stock.price.toFixed(2)}&nbsp;
          <span className={isPositive ? 'landing-welcome-banner__card-positive' : 'landing-welcome-banner__card-negative'}>
            {isPositive ? '▲' : '▼'} {Math.abs(stock.changePercent).toFixed(2)}%
          </span>
        </span>
        {stock.hireDateChangePercent !== undefined && (
          <span className="landing-welcome-banner__card-sub">
            Since Day 1:&nbsp;
            <span className="landing-welcome-banner__card-dollar-amount">
              {stock.hireDateChange! >= 0 ? '+$' : '-$'}
              {Math.abs(stock.hireDateChange!).toFixed(0)}
            </span>
            &nbsp;
            <span className="landing-welcome-banner__card-dollar-amount">
              ({stock.hireDateChange! >= 0 ? '+' : ''}
              {stock.hireDateChangePercent.toFixed(0)}%)
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

export default StockCard;
